/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { VcdrOrgInfo } from './vcdrOrgInfo';
import { VcdrOrgsInfoSummary } from './vcdrOrgsInfoSummary';


export interface VcdrOrgsInfoResult { 
    /**
     * Time at which result was created and cached
     */
    generated_at: string;
    time_elapsed_sec: number;
    summary: VcdrOrgsInfoSummary;
    vcdr_org_info: Array<VcdrOrgInfo>;
}

